import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import FoodsFields from './FoodsFields'

export const FoodEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <FoodsFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default FoodEdit
